import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_LetterRequestCustomer_Review, LetterRequestCustomer_Review } from 'src/app/Interface/LetterRequestCustomer_Review';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterrequestcustomerEvaluateService } from 'src/app/Service/Letter/LetterrequestcustomerEvaluate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-LetterRequestCustomerReviewForm',
  templateUrl: './LetterRequestCustomerReviewForm.component.html',
  styleUrls: ['./LetterRequestCustomerReviewForm.component.scss']
})
export class LetterRequestCustomerReviewFormComponent implements OnInit {
  @Input() inner_Evaluate:LetterRequestCustomer_Review=Empty_LetterRequestCustomer_Review()

  constructor(
    private LetterrequestcustomerEvaluate_Service:LetterrequestcustomerEvaluateService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.FormEvaluate = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
      Type: new FormControl("0", Validators.required),
    })

    this.get_Form_Title().setValue(this.inner_Evaluate.title)
    this.get_Form_Type().setValue(this.inner_Evaluate.type)
    this.Option=this.inner_Evaluate.option

    this.Nav_Service.CheckValidPage(2172).subscribe(
      data => {

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#region  Form Add

  FormEvaluate:FormGroup;

  get_Form_Title(){
    return this.FormEvaluate.get('Title') as FormControl;
  }

  get_Form_Type(){
    return this.FormEvaluate.get('Type') as FormControl;
  }

  //#endregion

 //#region Dsc Option
 Option: Array<string> = []
 Option_Modir: Array<boolean> = []
 Option_Input: string = ''

 Option_Delete(id) {
   this.Option.splice(id, 1)
   this.Option_Modir.splice(id, 1)
   this.Alertify_Service.SuccessMessage(" حذف شد")
 }

 Option_Submit() {
   if (!this.Option_Input) {
     this.Alertify_Service.ErrorMessage("عنوان گزینه را وارد نمائید")
   }
   else {
     this.Option.push(this.Option_Input)
     this.Option_Modir.push(false)

     this.Option_Input = ''
     this.Alertify_Service.SuccessMessage('اطلاعات ثبت شد')
   }

 }

 //#endregion



  InProccessing:boolean=false

  SubmitFormEvaluate() {

    if (this.get_Form_Type().value == '0') {
      this.Alertify_Service.ErrorMessage("نوع را انتخاب نمائید")
    }
    else {
      var Record: LetterRequestCustomer_Review = Empty_LetterRequestCustomer_Review()
      Record.id = this.inner_Evaluate.id
      Record.title = this.get_Form_Title().value
      Record.type = Number(this.get_Form_Type().value)

      this.InProccessing = true
      this.LetterrequestcustomerEvaluate_Service.AddEdit(Record, this.Option).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 10 سوال فعال نمی باشد")
          }
          else {
            if (this.inner_Evaluate.id == 0)
            {
              this.FormEvaluate.reset()
              this.get_Form_Type().setValue("0")
              this.Option=[]
            }

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }
  }

}
